import HeroSection from "@/components/home/HeroSection";
import ProblemSection from "@/components/home/ProblemSection";
import WhereRiskSection from "@/components/home/WhereRiskSection";
import WhatWeDoSection from "@/components/home/WhatWeDoSection";
import CaseNarrativeSection from "@/components/home/CaseNarrativeSection";
import AudienceSection from "@/components/home/AudienceSection";
import CoreQuestionSection from "@/components/home/CoreQuestionSection";
import { DotJourneyPath } from "@/components/AboriginalPatterns";
import SEO from "@/components/SEO";

const Index = () => {
  return (
    <div className="bg-background">
      <SEO
        title="Boomerang Cultures — Execution Risk Advisory for M&A"
        description="Advisory for M&A firms, CEOs, boards, and PE partners. Recognize execution risk in leadership before it shows up after close."
        path="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Service",
          name: "Execution Risk Advisory",
          provider: { "@type": "Organization", name: "Boomerang Cultures", url: "https://boomerangcultures.com" },
          serviceType: "Leadership and execution risk advisory for mergers and acquisitions",
          areaServed: "Global",
        }}
      />
      <HeroSection />

      <div className="px-6 opacity-50">
        <DotJourneyPath className="text-primary" />
      </div>

      <ProblemSection />
      <WhereRiskSection />
      <WhatWeDoSection />

      <div className="px-6 opacity-40">
        <DotJourneyPath className="text-ochre" />
      </div>

      <CaseNarrativeSection />
      <AudienceSection />
      <CoreQuestionSection />
    </div>
  );
};

export default Index;
